import { Flex, Text, Spinner } from "../../../../components";
import React, { useState } from "react";
import styled from "styled-components";
import moment from '../../../../utils/MomentConst';
import axios from 'axios';

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg};
  margin-bottom: 5px;
`;

const Container = styled(Flex)`
  flex-direction: column;
  width: 100%;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
  background: #161930;
  border-radius: 5px;
  padding: 18px 24px;
  margin-bottom: 12px;
`;

const TruncateText = styled(Text.Body)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const KeyPath = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [logData, setLogData] = useState(null);

  const pullLogs = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      axios
        .get(`/api/admin/licenses/logs/${data.id}`)
        .then(res => {
          setLogData(res.data.logs);
          setIsOpen(!isOpen)
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  return (
    <Container minw="600px">
      <Flex w="100%" onClick={() => pullLogs()}>
        <Flex w="40%">
          <TruncateText>{data.key}</TruncateText>
        </Flex>
        <Flex w="40%">
          <TruncateText>{data.owner_discord_id ? data.owner_discord_id : "N/A"}</TruncateText>
        </Flex>
        <Flex fg="1" />
        <Button bg="transparent" style={{ padding: 0, height: 12 }}>{isOpen ? "-" : "+"}</Button>
      </Flex>
      {isOpen &&
        <>
          <Flex w="100%" style={{ marginTop: 18 }}>
            <Flex w="40%">
              <TruncateText>Previous Key</TruncateText>
            </Flex>
            <Flex w="20%">
              <TruncateText>Previous Owner</TruncateText>
            </Flex>
            <Flex w="20%">
              <TruncateText>Date</TruncateText>
            </Flex>
          </Flex>
          {logData.map((log) => {
            const jsonData = JSON.parse(log.old_value);

            return (
              <Flex w="100%" style={{ marginTop: 18 }}>
                <Flex w="40%">
                  <TruncateText>{jsonData.previous_key}</TruncateText>
                </Flex>
                <Flex w="20%">
                  <TruncateText>{jsonData.previous_owner_id}</TruncateText>
                </Flex>
                <Flex w="20%">
                  <TruncateText>{moment(log.createdAt).format('MMMM D, YYYY, HH:MM:SS')}</TruncateText>
                </Flex>
              </Flex>
            )
          })}
        </>
      }
    </Container>
  )
}

export default KeyPath;
